import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChildMe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M11.861,3.66a2.252,2.252,0,1,1-3.185,0,2.252,2.252,0,0,1,3.185,0",
			transform: "translate(-2.35 3.912)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M10.344,3.4a1.364,1.364,0,1,1-1.929,0,1.364,1.364,0,0,1,1.929,0",
			transform: "translate(8.707 7.053)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M8.088,14.008c2.574,0,5.088,1.112,5.088,2.822V17.4a.566.566,0,0,1-.565.565H3.565A.566.566,0,0,1,3,17.4V16.83c0-1.711,2.513-2.822,5.088-2.822",
			transform: "translate(-0.17 -0.873)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M6.081,14.008c1.559,0,3.081.673,3.081,1.709v.342a.342.342,0,0,1-.342.342H3.342A.342.342,0,0,1,3,16.059v-.342c0-1.036,1.522-1.709,3.081-1.709",
			transform: "translate(12.006 0.686)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgChildMe;
